import Clipboard from './clipboard';
import './clipboard.scss';

export default Clipboard;
